<template>
    <div class="detail">
        <div class="nav">
          <go-back
            class="pa go-back"
          ></go-back>
          <span
            class="item fs16 font333 pointer"
            v-for="(item,index) of navList"
            :key="index"
            @click="tabChange(item)"
            :class="{ on: getActive(item) }"
            >{{item.name}}</span>
        </div>
        <div class="view-outer pc-padding30-mobil-padding20">
            <router-view
              :account-mt-id="+$route.params.mtid"
            ></router-view>
        </div>
    </div>
</template>
<!--
将概览, 我订阅的,交易周期三个tab整合为一个,将支出挪出来作为单独页面
-->
<script>
    import { setIsMaster } from '@/utils/common';
    import { mapGetters } from 'vuex';
  export default {
    name: 'index',
    data() {
      let _this = this;
      return {
        navList: [
          {
            name:_this.$t('my_subscriptions'),
            routerName: 'mamSubSubscription'
          },
          {
            name: _this.$t('expenses'),
            routerName: 'mamSubExpend'
          },
        ]
      };
    },
    created(){
      setIsMaster(this,true);
    },
    mounted() {
      let reouterview = document.getElementById('routerview');
      if(!reouterview) return;
      reouterview.classList.add('no-padding-import');
    },
    beforeDestroy(){
      let reouterview = document.getElementById('routerview');
      if(reouterview){
        reouterview.classList.remove('no-padding-import');
      }
    },
    computed: {
      ...mapGetters(['userInfo','detailsIsMaster']),
    },
    methods: {
      tabChange(item) {
        this.$router.push({name: item.routerName});
      },
      getActive(item){
        return item.routerName == this.$route.name;
      }
    }
  };
</script>
<style lang="scss" scoped>
.detail {

}
</style>
